import { createAction } from '@reduxjs/toolkit'

export { updateDomainData } from './updateDomainData'
export const replaceDomainData = createAction<uui.domain.PublicData>('domain/replaceData')
